var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link 1",
    clipPath: "url(#clip0_0_847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0114 24.0111L27.4273 18.8351L24.0114 17.955C23.564 16.6126 22.8031 15.3446 21.7292 14.2706C20.67 13.2115 19.4171 12.4358 18.0448 11.9883L18 12.0331L13.8383 11.869L11.9886 11.9883C10.6163 12.4358 9.36337 13.2115 8.30426 14.2706L2.77446 19.8004C-0.92482 23.4997 -0.92482 29.512 2.77446 33.2113C6.57816 37.0149 12.5896 36.8211 16.1994 33.2113L21.7292 27.6955C22.8033 26.6214 23.564 25.3536 24.0114 24.0111ZM12.4703 29.482C10.7996 31.1527 8.1296 31.108 6.50362 29.482C4.86281 27.8412 4.86281 25.1562 6.50362 23.5154L11.9886 18.0444L14.9869 21.0128L18.0001 23.9663L12.4703 29.482Z",
    fill: "#384949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7291 27.6954L16.1993 33.2111C12.5895 36.821 6.57811 37.0148 2.77441 33.2111L6.50351 29.482C8.12949 31.108 10.7995 31.1527 12.4702 29.482L18 23.9663L14.9869 21.0128L21.7291 14.2705C22.8031 15.3445 23.5639 16.6124 24.0114 17.9549L27.4272 18.835L24.0114 24.011C23.5639 25.3536 22.8031 26.6214 21.7291 27.6954Z",
    fill: "#384949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.1876 30.6789L27.6959 29.1872C27.2837 28.7749 27.2837 28.1077 27.6959 27.6955C28.1081 27.2833 28.7753 27.2833 29.1876 27.6955L30.6793 29.1872C31.0915 29.5994 31.0915 30.2666 30.6793 30.6789C30.2669 31.0911 29.5998 31.0911 29.1876 30.6789Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.81265 8.30398L5.3209 6.8123C4.90866 6.40006 4.90866 5.73286 5.3209 5.32069C5.73314 4.90852 6.40034 4.90845 6.81251 5.32069L8.30412 6.8123C8.71636 7.22454 8.71636 7.89174 8.30412 8.30391C7.89188 8.71608 7.22482 8.71615 6.81265 8.30398Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.2445 21.5482C31.3953 20.9851 31.9736 20.6516 32.5366 20.8023L34.5745 21.3486C35.1376 21.4965 35.4697 22.0777 35.3204 22.6407C35.1696 23.2037 34.5913 23.5373 34.0283 23.3865L31.9904 22.8403C31.4311 22.6906 31.0936 22.1146 31.2445 21.5482Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.680086 13.3587C0.830836 12.7956 1.40916 12.4621 1.97215 12.6128L4.01009 13.1591C4.57097 13.3062 4.90594 13.8875 4.75596 14.4512C4.60521 15.0143 4.02689 15.3478 3.4639 15.1971L1.42596 14.6508C0.866625 14.5011 0.529125 13.9251 0.680086 13.3587Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.3491 34.574L20.8028 32.5361C20.6521 31.973 20.9856 31.3948 21.5487 31.244C22.1118 31.0933 22.6893 31.4246 22.8408 31.9899L23.387 34.0278C23.5378 34.5909 23.2042 35.1691 22.6411 35.3199C22.0749 35.4708 21.4988 35.1333 21.3491 34.574Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.1592 4.00966L12.6129 1.97172C12.4621 1.40866 12.7957 0.830406 13.3588 0.679656C13.9218 0.530383 14.5008 0.860289 14.6508 1.42553L15.1971 3.46347C15.3479 4.02653 15.0143 4.60478 14.4513 4.75553C13.885 4.90628 13.309 4.56885 13.1592 4.00966Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.2253 2.78826C29.526 -0.911023 23.5146 -0.925999 19.8004 2.78826L14.2706 8.30399C13.1967 9.37794 12.4359 10.6458 11.9883 11.9884C11.332 13.9574 11.332 16.0755 11.9884 18.0445C12.4359 19.3869 13.1967 20.655 14.2706 21.729C15.3148 22.7732 16.5678 23.5487 17.9551 24.0112L17.9998 23.9664C19.6407 22.3256 19.6406 19.6406 17.9998 17.9998C16.359 16.359 16.359 13.674 17.9998 12.0332L23.5296 6.51742C24.3351 5.71185 25.3793 5.29427 26.513 5.29427C26.5427 5.26452 26.7963 5.27936 26.856 5.30917C27.6615 5.3091 28.7205 5.74166 29.4962 6.51742C31.137 8.15823 31.1371 10.8432 29.4962 12.4841L24.0113 17.9549C24.6676 19.924 24.6676 22.0421 24.0113 24.0112C25.3686 23.5488 26.6515 22.7731 27.6957 21.7289L33.2254 16.2132C36.9247 12.5138 36.9246 6.48754 33.2253 2.78826Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.0002 23.9663L17.9554 24.011C16.5682 23.5486 15.3151 22.773 14.271 21.7288L18.0002 17.9996C19.641 19.6405 19.641 22.3255 18.0002 23.9663Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.2254 16.2132L27.6956 21.729C26.6515 22.7732 25.3686 23.5489 24.0112 24.0112C24.6676 22.0422 24.6676 19.924 24.0112 17.955L29.4962 12.4841C31.1371 10.8433 31.137 8.15831 29.4962 6.51749L33.2253 2.78833C36.9247 6.48754 36.9248 12.5138 33.2254 16.2132Z",
    fill: "#FFBC00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.2fecad7c5d9e577cd30f3d675906286c.svg";
export { ForwardRef as ReactComponent };